"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SvgSidebarLodgesIcon = (0, react_1.forwardRef)((props, ref) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 24 24', fill: 'none', ref: ref }, props, { children: (0, jsx_runtime_1.jsx)("path", { stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M3 11l9-7 9 7M5 10v10h14V10M9 20v-5h6v5' }) })));
});
exports.default = (0, react_1.memo)(SvgSidebarLodgesIcon);
